// extracted by mini-css-extract-plugin
export default {"video__video":"divkit-c11f9","video__aspect-wrapper":"divkit-cfe32","video_aspect":"divkit-a4f5c"};